import React from 'react';
import { Box, Typography, Container } from '@mui/material';
import FeaturedCard from '../../components/featuredCard';
import usePublisher from '../../../store/models/publisher/usePublisher';
import * as styles from './styles';

function renderSectionHeader(section) {
    return (
        <Box sx={styles.sectionHeader}>
            <Box>
                <Typography sx={styles.eyebrow}>{section.label}</Typography>
                <Typography variant="h2" sx={styles.title}>{section.title}</Typography>
                <Typography variant="body1" sx={styles.subtitle}>
                    {section.description}
                </Typography>
            </Box>
        </Box>
    );
}

function renderGrid(publishers, onSync, onShare) {
    return (
        <Box sx={styles.grid}>
            {publishers.map((publisher) => (
                <FeaturedCard
                    key={publisher.id}
                    publisher={publisher}
                    onSync={onSync}
                    onShare={onShare}
                />
            ))}
        </Box>
    );
}

function Featured({ onSync, onShare }) {
    const { featuredPublishers, featuredSection } = usePublisher();

    return (
        <Box component="section" sx={styles.section}>
            <Container maxWidth="xl" sx={{ px: { xs: 2, sm: 3, md: 4 } }}>
                {renderSectionHeader(featuredSection)}
                {renderGrid(featuredPublishers, onSync, onShare)}
            </Container>
        </Box>
    );
}

export default Featured;
